/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';

import { SecurityHelper } from 'sarsaparilla';

import {
    HOMEPAGE_FEATURED_VERSION,
    ARTICLE_VERSION,
    ARTICLES_VERSION,
} from 'shared-ui/constants';

import type {
    AllArticlesParams,
    ArticleContentResponse,
    ArticlesResponse,
} from './articles.types';

/** ServiceNow content requests are authenticated with the current auth header. */
function getAuthHeaders(): Record<string, string> {
    return { Authorization: SecurityHelper.getAuthHeader() };
}

export async function getHomepageArticles(
    signal?: AbortSignal
): Promise<ArticlesResponse> {
    return axios
        .get<ArticlesResponse>(
            `${process.env.SN_API}/${HOMEPAGE_FEATURED_VERSION}/content/homepage`,
            { headers: getAuthHeaders(), signal }
        )
        .then(({ data }) => data);
}

export async function getFeaturedArticles(
    signal?: AbortSignal
): Promise<ArticlesResponse> {
    return axios
        .get<ArticlesResponse>(
            `${process.env.SN_API}/${HOMEPAGE_FEATURED_VERSION}/content/featured`,
            { headers: getAuthHeaders(), signal }
        )
        .then(({ data }) => data);
}

export async function getArticleById(
    articleId: string,
    signal?: AbortSignal
): Promise<ArticleContentResponse> {
    return axios
        .get<ArticleContentResponse>(
            `${process.env.SN_API}/${ARTICLE_VERSION}/content/article/${articleId}`,
            { headers: getAuthHeaders(), signal }
        )
        .then(({ data }) => data);
}

export async function getAllArticles(
    { offset, limit }: AllArticlesParams,
    signal?: AbortSignal
): Promise<ArticlesResponse> {
    return axios
        .get<ArticlesResponse>(
            `${process.env.SN_API}/${ARTICLES_VERSION}/content/all?offset=${offset}&limit=${limit}`,
            { headers: getAuthHeaders(), signal }
        )
        .then(({ data }) => data);
}
